import type { RootState } from '../store'

export const selectNotifiedActivityIds = (state: RootState) => state.activities.notifiedActivityIds

export const selectTestNotificationTrigger = (state: RootState) => state.activities.testNotificationTrigger
export const selectGameHudReminder = (state: RootState) => state.activities.gameHudReminder
